import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { Login } from './pages/Login';
import { Confirm } from './pages/Confirm';
import { Home } from './pages/Home';
import { Programs } from './pages/Programs';
import { ProgramDetail } from './pages/ProgramDetail';
import { Themes } from './pages/Themes';
import { NewTheme } from './pages/NewTheme';
import { ThemeDetail } from './pages/ThemeDetail';
import { Organizers } from './pages/Organizers';
import { Merchants } from './pages/Merchants';
import { Guests } from './pages/Guests';
import { GuestDetail } from './pages/GuestDetail';
import { Transactions } from './pages/Transactions';
import { TransactionDetail } from './pages/TransactionDetail';
import { NewUserTransaction } from './pages/NewUserTransaction';
import { NewMerchantTransaction } from './pages/NewMerchantTransaction';
import { AuthGuard } from './components/AuthGuard';
import { Layout } from './components/Layout';

export const App = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/confirm" element={<Confirm />} />
          <Route element={<AuthGuard />}>
            <Route element={<Layout />}>
              <Route path="/home" element={<Home />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/programs/:uid" element={<ProgramDetail />} />
              <Route path="/themes" element={<Themes />} />
              <Route path="/themes/new" element={<NewTheme />} />
              <Route path="/themes/:uid" element={<ThemeDetail />} />
              <Route path="/organizers" element={<Organizers />} />
              <Route path="/merchants" element={<Merchants />} />
              <Route path="/guests" element={<Guests />} />
              <Route path="/guests/:uid" element={<GuestDetail />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/transactions/user/new" element={<NewUserTransaction />} />
              <Route path="/transactions/merchant/new" element={<NewMerchantTransaction />} />
              <Route path="/transactions/:uid" element={<TransactionDetail />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
